// extracted by mini-css-extract-plugin
export default {"dashboard-info":"info_dashboard-info__3qRDz"};